var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.97 2.75C6.86134 2.75 2.71997 6.89137 2.71997 12C2.71997 17.1086 6.86134 21.25 11.97 21.25C17.0786 21.25 21.22 17.1086 21.22 12C21.22 6.89137 17.0786 2.75 11.97 2.75ZM1.21997 12C1.21997 6.06294 6.03291 1.25 11.97 1.25C17.907 1.25 22.72 6.06294 22.72 12C22.72 17.9371 17.907 22.75 11.97 22.75C6.03291 22.75 1.21997 17.9371 1.21997 12Z",
    fill: "#252526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.789 14.6814C10.7994 14.0616 10.8698 13.572 11 13.2126C11.1302 12.8532 11.3958 12.4548 11.7968 12.0173L12.8203 10.9626C13.2578 10.4678 13.4765 9.93657 13.4765 9.36887C13.4765 8.82199 13.3333 8.39491 13.0468 8.08762C12.7604 7.77512 12.3437 7.61887 11.7968 7.61887C11.2656 7.61887 10.8385 7.75949 10.5156 8.04074C10.1927 8.32199 10.0312 8.69959 10.0312 9.17355H8.58591C8.59632 8.3298 8.8958 7.65012 9.48435 7.13449C10.0781 6.61366 10.8489 6.35324 11.7968 6.35324C12.7812 6.35324 13.5468 6.61887 14.0937 7.15012C14.6458 7.67616 14.9218 8.40012 14.9218 9.32199C14.9218 10.2334 14.5 11.1319 13.6562 12.0173L12.8047 12.8611C12.4244 13.2829 12.2343 13.8897 12.2343 14.6814H10.789ZM10.7265 17.1579C10.7265 16.9236 10.7968 16.7282 10.9375 16.572C11.0833 16.4105 11.2968 16.3298 11.5781 16.3298C11.8593 16.3298 12.0729 16.4105 12.2187 16.572C12.3646 16.7282 12.4375 16.9236 12.4375 17.1579C12.4375 17.3923 12.3646 17.5876 12.2187 17.7439C12.0729 17.8949 11.8593 17.9704 11.5781 17.9704C11.2968 17.9704 11.0833 17.8949 10.9375 17.7439C10.7968 17.5876 10.7265 17.3923 10.7265 17.1579Z",
    fill: "#252526"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.45dd901052240d3df7b6cf907937dfdc.svg";
export { ForwardRef as ReactComponent };